import { useEffect } from 'react';
import { usePostHog } from '@/lib/posthogProvider';
import { setServedPage } from '@/utils/servedPage';
import { recordSplitUrlExposures } from '@/utils/splitUrlExposure';

/** Split-url tracking for a rendered lander: the page served, and the experiment exposure. */
export function useSplitUrlTracking(servedPagePath: string | null): void {
	const posthog = usePostHog();

	// During render, not in an effect: child components read it in their own mount effects, which
	// run before this component's effects.
	if (typeof window !== 'undefined') setServedPage(servedPagePath);

	useEffect(() => {
		// Tells the arms of a split-url test apart on every event of this visit.
		posthog.register_for_session({ served_path: servedPagePath });
	}, [posthog, servedPagePath]);

	useEffect(() => {
		recordSplitUrlExposures();
	}, [servedPagePath]);
}
